module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Сохраненные способы оплаты","subtitle":"Для добавления новой карты, мы заблокируем и разблокируем 1 рубль с вашей карты. Вы будете перенаправлены на сайт платежной системы.","noPaymentMethods":"У вас нет сохранённых способов оплаты"}}')
  delete Component.options._Ctor
}
